import { forwardRef } from 'react';

export const GescheftshausIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 110 110" ref={ref} {...props}>
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth={3}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M5.5 96.8h100M94.2 16.4H15.3v73h78.9v-73z"
        />
        <path
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={3}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M31.8 24.5h-9.5v13.1h9.5V24.5zm18.3 0h-9.5v13.1h9.5V24.5zm18.3 0h-9.5v13.1h9.5V24.5zm18.3 0h-9.5v13.1h9.5V24.5z"
        />
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth={3}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M31.8 44.6h-9.5v13.1h9.5V44.6zm18.3 0h-9.5v13.1h9.5V44.6zm18.3 0h-9.5v13.1h9.5V44.6z"
        />
        <path
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={3}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M86.7 44.6h-9.5v13.1h9.5V44.6zM31.8 64.8h-9.5v14.1h9.5V64.8z"
        />
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth={3}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M50.1 64.8h-9.5v24.4h9.5V64.8z"
        />
        <path
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={3}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M68.4 64.8h-9.5v14.1h9.5V64.8zm18.3 0h-9.5v14.1h9.5V64.8z"
        />
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth={3}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M94.2 11.5H15.3v4.9h78.9v-4.9z"
        />
      </svg>
    );
  },
);
